import { Controller } from "@hotwired/stimulus"

export default class DialogModalController extends Controller {
  static targets = ["modal"]
  static values = {
    initiallyOpen: { type: Boolean, default: false },
  }

  connect() {
    if (this.hasModalTarget && this.modalTarget.open) {
      this.close()
      return
    }

    if (this.initiallyOpenValue) {
      this.open()
    }

    this.modalTarget.addEventListener("close", () => {
      this.dispatch("close")
    })
  }

  modalTargetDisconnected() {
    this.modalTarget.removeEventListener("close", () => {
      this.dispatch("close")
    })
  }

  preventDefault = (event) => {
    event.preventDefault()
  }

  open() {
    this.modalTarget.showModal()
  }

  close() {
    this.modalTarget.close()
  }
}
